import { render, staticRenderFns } from "./SystemChoiceControl.vue?vue&type=template&id=3ae4fb12&scoped=true"
import script from "./SystemChoiceControl.vue?vue&type=script&lang=js"
export * from "./SystemChoiceControl.vue?vue&type=script&lang=js"
import style0 from "./SystemChoiceControl.vue?vue&type=style&index=0&id=3ae4fb12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae4fb12",
  null
  
)

export default component.exports